// Generated by Melange

import * as Buhta_cabinet__Route from "../../Route.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Cn from "../../../../../vendored/classnames/Cn.js";
import * as Curry from "melange.js/curry.js";
import * as ReasonReactRouter from "reason-react/ReasonReactRouter.js";
import * as JsxRuntime from "react/jsx-runtime";

function handleClick(ev, to_) {
  const metaClick = ev.metaKey || ev.ctrlKey || ev.altKey || ev.shiftKey;
  if (!metaClick) {
    ev.preventDefault();
    ev.stopPropagation();
    return ReasonReactRouter.push(to_);
  }
  
}

function Link(Props) {
  let route = Props.route;
  let classNameOpt = Props.className;
  let tabIndex = Props.tabIndex;
  let onLinkClickedOpt = Props.onLinkClicked;
  let children = Props.children;
  let disabledOpt = Props.disabled;
  let urlParamsOpt = Props.urlParams;
  let targetOpt = Props.target;
  let onMouseEnterOpt = Props.onMouseEnter;
  let onMouseLeaveOpt = Props.onMouseLeave;
  const className = classNameOpt !== undefined ? classNameOpt : "";
  const onLinkClicked = onLinkClickedOpt !== undefined ? onLinkClickedOpt : (function (param) {
      
    });
  const disabled = disabledOpt !== undefined ? disabledOpt : false;
  const urlParams = urlParamsOpt !== undefined ? urlParamsOpt : /* [] */ 0;
  const target = targetOpt !== undefined ? targetOpt : "_self";
  const onMouseEnter = onMouseEnterOpt !== undefined ? onMouseEnterOpt : (function (param) {
      
    });
  const onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : (function (param) {
      
    });
  const href = Buhta_cabinet__Route.urlWithParams(Buhta_cabinet__Route.toString(route), urlParams);
  const onClick = function (ev) {
    if (disabled) {
      return;
    } else {
      handleClick(ev, href);
      window.scrollTo(0, 0);
      return Curry._1(onLinkClicked, undefined);
    }
  };
  let tmp = {
    children: children,
    className: Cn.$plus("cursor-pointer", className),
    disabled: disabled,
    href: href,
    target: target,
    onClick: onClick,
    onMouseEnter: onMouseEnter,
    onMouseLeave: onMouseLeave
  };
  if (tabIndex !== undefined) {
    tmp.tabIndex = Caml_option.valFromOption(tabIndex);
  }
  return JsxRuntime.jsx("a", tmp);
}

const make = Link;

export {
  handleClick,
  make,
}
/* Buhta_cabinet__Route Not a pure module */
